import { ConfigService } from '@/configuration/services/configService';

/** Причина записи жучком вне PROD: там прямая запись — инструмент отладки, её не спрашиваем. */
export const DIRECT_WRITE_DEFAULT_REASON = 'DebugPanel: прямая запись реквизита';

/** Окружения, где жучок пишет без подтверждения; значения `environment` из config.json сравниваются без регистра. */
const NON_PRODUCTION_ENVIRONMENTS = new Set(['DEV', 'TEST']);

/**
 * На PROD жучок перед прямой записью спрашивает причину и показывает «было → стало»; на DEV/TEST пишет сразу.
 * Fail-closed: нет конфига, пустое или незнакомое окружение (STAGE, PREPROD…) — подтверждение как на PROD.
 * Сервер окружения не различает — он только требует непустую причину.
 */
export const isDirectWriteConfirmRequired = (): boolean => {
    const environment = ConfigService.get()?.environment;
    return typeof environment !== 'string' || !NON_PRODUCTION_ENVIRONMENTS.has(environment.trim().toUpperCase());
};

/** Короткое значение для строки «было → стало». */
export const directWriteDisplay = (value: unknown): string => {
    if (value === null || value === undefined) return 'null';
    if (Array.isArray(value)) return `${value.length} стр.`;
    if (value === true) return '1';
    if (value === false) return '0';
    const text =
        value instanceof Date
            ? value.toISOString()
            : typeof value === 'string' || typeof value === 'number'
              ? String(value)
              : JSON.stringify(value);
    if (!text) return '«пустая строка»';
    return text.length > 80 ? `${text.slice(0, 77)}…` : text;
};
